import { formatContentSelectValue } from '../utils'
import api from './connectionProxy'

export const getContents = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '', filter = '' } = params
  return api.http.get('/contents/', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term,
      filter,
    },
  })
}

export const getChapterContentsByIsbn = (isbn) => {
  return getContents({
    page: 0,
    perPage: 100,
    term: isbn,
    filter: 'tipo:capitulo',
  })
}

export const getVectorizationChapterStatus = (isbn, idVetores = []) => {
  return api.http.post('/contents/vectorization-chapters/status', {
    tipo: 'capitulo',
    isbn,
    idVetores,
  })
}

export const getContent = (id) => {
  return api.http.get(`/contents/${id}`)
}

export const getContentAvaibleExports = (id) => {
  return api.http.get(`/contents/${id}/available_exports`)
}

export const downloadContent = ({ id, type }) => {
  return api.http.get(`/contents/${id}/download/${type}`, { responseType: 'arraybuffer' })
}

export const deleteContent = (id) => {
  return api.http.delete(`/contents/${id}`)
}

export const restoreContent = (id) => {
  return api.http.put(`/contents/${id}/restore`)
}

export const editContent = (data, _id) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }
  return api.http.put(`/contents/${_id}`, data, config)
}

export const addContent = (data, idVetor) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }
  const params = idVetor ? `?idVetor=${encodeURIComponent(idVetor)}` : ''
  return api.http.post(`/contents${params}`, data, config)
}

export const getHtmlPreview = (data) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }
  return api.http.post('/contents/html_preview', data, config)
}

export const getLogs = (id) => {
  return api.http.get(`/contents/${id}/logs`)
}

export const searchContents = ({ term, type }) => {
  return api.http.get('/contents/select_search', {
    params: {
      term,
      type,
    },
  })
}

export const getSelectContents = (type) => (term, callback) => {
  searchContents({ type, term }).then((response) => {
    const { data } = response
    const options = formatContentSelectValue(data)

    callback(null, {
      options,
      complete: true,
    })
  })
}

export const reindex = () => api.http.get('/contents/reindex')

export const checkStatusJob = () => {
  return api.http.get('/contents/check_status_job')
}



// WEBPACK FOOTER //
// ./src/api/content.js